import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import PickWave from '../entities/pick-wave'
import PickWaveObject from '../entities/pick-wave-object'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import Util from '@/lib/util';

interface PickWaveCreatedState extends ListState<PickWaveObject> {
    objects: Array<PickWaveObject>,
    totalCountSelectedObject : number,
    currentPageSelectedObject : number,
    pageSizeSelectedObject : number,
}
class PickWaveCreatedModule extends ListModule<PickWaveCreatedState, any, PickWaveObject>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        totalCountSelectedObject : 0,
        currentPageSelectedObject : 1,
        pageSizeSelectedObject : 10,
        list: new Array<PickWaveObject>(),
        loading: false,
    }
    actions = {
        async searchObjects(context: ActionContext<PickWaveCreatedState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/So/SearchObjectSoForPickWave', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<PickWaveObject>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async checkWorkOrder(context: ActionContext<PickWaveCreatedState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/PickWave/CheckWorkerOrder', payload.data);
            return reponse.data.result;
        },
        async create(context: ActionContext<PickWaveCreatedState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/PickWave/CreateEmptyPickwave', payload.data);
            return reponse.data.result;
        },
        async PushObject(context: ActionContext<PickWaveCreatedState, any>, payload: any) {
            let reponse = await Ajax.put('/api/services/app/PickWave/PushObject', payload);
            return reponse.data.result;
        },
        async AllocateItems(context: ActionContext<PickWaveCreatedState, any>, payload: any) {
            let reponse = await Ajax.put('/api/services/app/PickWave/AllocateItems', payload);
            return reponse.data.result;
        },
        async CreatePickList(context: ActionContext<PickWaveCreatedState, any>, payload: any) {
            let reponse = await Ajax.put('/api/services/app/PickWave/CreatePickList', payload);
            return reponse.data.result;
        },
        async RevertObject(context: ActionContext<PickWaveCreatedState, any>, payload: any) {
            let reponse = await Ajax.put('/api/services/app/PickWave/RevertObject', payload);
            return reponse.data.result;
        },
        async CancelToCreatePickwave(context: ActionContext<PickWaveCreatedState, any>, payload: any) {
            let reponse = await Ajax.put('/api/services/app/PickWave/CancelToCreatePickwave');
            return reponse.data.result;
        },
    };
    mutations = {
        setCurrentPage(state: PickWaveCreatedState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: PickWaveCreatedState, pagesize: number) {
            state.pageSize = pagesize;
        },
        setCurrentPageSelectedObject(state: PickWaveCreatedState, page: number) {
            state.currentPageSelectedObject = page;
        },
        setPageSizeSelectedObject(state: PickWaveCreatedState, pagesize: number) {
            state.pageSizeSelectedObject = pagesize;
        },
    }
}
const pickWaveCreatedModule = new PickWaveCreatedModule();
export default pickWaveCreatedModule;